module.exports = __webpack_public_path__ + "static/media/contact2.cae48389.jpg";